var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27713_34379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.23 7.00003H18.83C18.77 6.53003 18.47 6.06003 18.04 5.83003L11.4 2.45003C10.84 2.16003 10.17 2.16003 9.6 2.44003L2.8 5.83003C2.32 6.09003 2 6.64003 2 7.17003V15C2 16.1 2.9 17 4 17V7.40003L10.5 4.00003L16.23 7.00003Z",
    fill: "#4E5968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 8H7C5.9 8 5 8.9 5 10V19C5 20.1 5.9 21 7 21H20C21.1 21 22 20.1 22 19V10C22 8.9 21.1 8 20 8ZM20 11.46C20 11.79 19.81 12.1 19.52 12.25L13.91 15.13C13.66 15.26 13.35 15.26 13.1 15.13L7.49 12.25C7.19 12.1 7 11.79 7 11.46C7 10.79 7.7 10.36 8.3 10.67L13.5 13.34L18.7 10.67C19.3 10.36 20 10.79 20 11.46Z",
    fill: "#4E5968"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27713_34379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.ee125126095e7a38785488592bd75062.svg";
export { ForwardRef as ReactComponent };